import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import ContentLine from './ContentLine';
import ReferralContainer from './ReferralContainer';
import CustomerProfileOverview from './CustomerProfileOverview';
import IcGroup from './CustomerDetailIcons/IcGroup';
import IcLike from './CustomerDetailIcons/IcLike';
import IcHearth from './CustomerDetailIcons/IcHearth';
import IcColor from './CustomerDetailIcons/IcColor';
import customerSelectors from 'features/customer/services/selectors';
import { formatPhone } from 'utils/formatPhone';
import moment from 'moment';
import AccountPackage from './AccountPackage';

const LeftCustomerDetailsContent = () => {
  const customerDetails = customerSelectors.getCustomerDetails();

  // const images = [
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  // ];

  return (
    <LeftStyled>
      <DetailsBoxStyled>
        <AccountPackage
          accountPackage={customerDetails?.accountPackage}
          name={customerDetails?.name}
        />
        <div style={{ display: 'flex', gap: '8px' }}>
          <div>
            <Row gutter={[8, 8]}>
              <ContentLine
                span={24}
                labelSpan={6}
                label='Phone'
                value={customerDetails?.phone ? formatPhone(customerDetails.phone) ?? '' : ''}
              />
              <ContentLine
                span={24}
                labelSpan={6}
                label='Email'
                value={customerDetails?.email || '--'}
              />
              <ContentLine
                span={24}
                labelSpan={6}
                label='DOB'
                value={
                  customerDetails?.birthday
                    ? moment(customerDetails?.birthday).format('MM-DD-YYYY')
                    : '-'
                }
              />
            </Row>
          </div>
          <div style={{ borderLeft: '1px solid #CCD4DC' }}></div>
          <div>
            <Row gutter={[8, 8]}>
              <ContentLine
                span={24}
                labelSpan={11}
                label='Created Date'
                value={
                  customerDetails?.createdDate
                    ? moment(customerDetails?.createdDate).format('MM-DD-YYYY')
                    : ''
                }
              />
              <ContentLine
                span={24}
                labelSpan={11}
                label='Last Visit Date'
                value={
                  customerDetails?.lastVisitedDate
                    ? moment(customerDetails?.lastVisitedDate).format('MM-DD-YYYY')
                    : ''
                }
              />
              <ContentLine
                span={24}
                labelSpan={11}
                label='Visited'
                value={customerDetails?.numberVisit || 0}
              />
            </Row>
          </div>
        </div>
      </DetailsBoxStyled>
      <AdvertiseBoxStyled>
        <ReferralContainer data={customerDetails} />
        <CustomerProfileOverview label='Note' icon={<IcGroup />}>
          {customerDetails?.note || '--'}
        </CustomerProfileOverview>
        <CustomerProfileOverview label='Hobbies' icon={<IcLike />}>
          {customerDetails?.hobbies || '--'}
        </CustomerProfileOverview>
        <CustomerProfileOverview label='Health' icon={<IcHearth />}>
          <ul>
            <li>{customerDetails?.health || '--'}</li>
          </ul>
        </CustomerProfileOverview>
        <CustomerProfileOverview label='Colors' icon={<IcColor />}>
          <ul>
            <li>{customerDetails?.color || '--'}</li>
          </ul>
        </CustomerProfileOverview>
        {/* <CustomerProfileOverview label='Images'>
          <ImageContainerStyled>
            {images.map((image) => (
              <Image
                key={image}
                width={77}
                height={77}
                src={image}
                alt='image'
                preview={false}
                style={{ borderRadius: '8px' }}
              />
            ))}
          </ImageContainerStyled>
        </CustomerProfileOverview> */}
      </AdvertiseBoxStyled>
    </LeftStyled>
  );
};

export default LeftCustomerDetailsContent;

const DetailsBoxStyled = styled.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const LeftStyled = styled.div`
  min-width: 620px;
  width: 30%;
  height: 100%;
  display: flex;
  padding-top: 24px;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
  background: #fff;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.25);
`;

const AdvertiseBoxStyled = styled.div`
  display: flex;
  padding: 8px 16px 24px 16px;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
  background: #f5f5f5;
  height: 100%;
`;

// const ImageContainerStyled = styled.div`
//   display: flex;
//   gap: 8px;
//   flex-wrap: wrap;
// `;
